import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

interface TabContent {
    [key: string]: string;
}

@Component({
    selector: 'demo-upp-tab-bar',
    templateUrl: './demo-upp-tab-bar.html',
    styleUrls: ['../demo-common.scss', './demo-upp-tab-bar.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppTabBarComponent {
    selectedTab = 'catalog';
    selectedTab2 = 'tables';

    tabContent: TabContent = {
        catalog: 'Browse your product catalog — categories, items, prices, and stock levels.',
        cart: 'Current order — 3 items totaling €12.50. Ready to checkout.',
        tickets: 'Recent tickets — view, reprint, or void past transactions.',
        settings: 'Configure tax rates, printers, payment methods, and staff permissions.',
    };

    tabContent2: TabContent = {
        tables: 'Manage table layout and active orders per table.',
        orders: 'Pending and completed orders for the current shift.',
        stats: 'Daily sales summary, top products, and revenue breakdown.',
    };

    constructor(private change: ChangeDetectorRef) {
    }

    onTabSelected(tab: string) {
        this.selectedTab = tab;
        this.change.markForCheck();
    }

    onTab2Selected(tab: string) {
        this.selectedTab2 = tab;
        this.change.markForCheck();
    }
}
